import React from 'react';

import { ArrowForward } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';
import { useLevelUpContext } from 'components/MeshList/levelUp/context';
import styled from 'styled-components';
import { FlexContainer, StyledIconButton, VerticallyAlignedFlexContainer } from 'styles/common';

import { EditWeightageIcon, PlusIcon3, StyledIconV2 } from 'constants/icons';
import theme from 'constants/theme';

import { Typography12, Typography13 } from 'uiToolkit/Typography';

const getCurrentAndTargetRole = (jobCompetencies = []) => {
  const { jobFunction: currentJobFunction, jobRole: currentJobRole } =
    jobCompetencies.find(({ isCurrentRole }) => isCurrentRole) ?? {};

  const { jobFunction: targetJobFunction, jobRole: targetJobRole } =
    jobCompetencies.find(({ isCurrentRole }) => !isCurrentRole) ?? {};

  return {
    currentJobFunction,
    currentJobRole,
    targetJobFunction,
    targetJobRole,
  };
};

const LevelUpMeshListHeader = ({ reportee }) => {
  const {
    state: { levelUpDetails, isLoading },
    openRoleSelectionModal,
  } = useLevelUpContext();

  const { currentJobFunction, currentJobRole, targetJobFunction, targetJobRole } = getCurrentAndTargetRole(
    levelUpDetails?.jobCompetencies
  );

  const { currentJobRole: currentJobRoleFallback } = levelUpDetails ?? {};
  const currentRole = currentJobRole?.name ?? currentJobRoleFallback?.name ?? '';
  const nextRole = targetJobRole?.name ?? '';

  return (
    <VerticallyAlignedFlexContainer
      style={{ padding: '1rem', width: '100%', borderBottom: `1px solid ${theme.palette.divider}` }}
    >
      <FlexContainer style={{ flexDirection: 'column', width: '100%' }}>
        <Typography13 weight={600}>{`${reportee.firstName}'s Progress`}</Typography13>
        {isLoading && <Skeleton />}
        {!isLoading && (
          <FlexContainer style={{ marginTop: '0.625rem' }}>
            {currentRole && (
              <TruncatedTypography12 customColor={theme.palette.text.label}>{currentRole}</TruncatedTypography12>
            )}
            {Boolean(nextRole) && (
              <StyledIconV2 color={theme.palette.text.label} style={{ margin: '0 0.5rem ' }} size="fixed12px">
                <ArrowForward />
              </StyledIconV2>
            )}
            {nextRole && (
              <TruncatedTypography12 customColor={theme.palette.text.label}>{nextRole}</TruncatedTypography12>
            )}
            {nextRole && (
              <VerticallyAlignedFlexContainer style={{ marginLeft: 'auto' }}>
                <StyledIconButton style={{ marginRight: 'auto' }} onClick={openRoleSelectionModal}>
                  <EditWeightageIcon color={theme.palette.primary.main} size="fixed16px" />
                </StyledIconButton>
              </VerticallyAlignedFlexContainer>
            )}
            {!nextRole && (
              <VerticallyAlignedFlexContainer
                style={{ marginLeft: 'auto', cursor: 'pointer' }}
                onClick={() => openRoleSelectionModal({ isNewRoleSelection: true })}
              >
                <ColoredIconButton style={{ marginRight: '0.5rem' }}>
                  <PlusIcon3 size="fixed10px" color="blue" />
                </ColoredIconButton>
                <Typography13 customColor="primary">New Role</Typography13>
              </VerticallyAlignedFlexContainer>
            )}
          </FlexContainer>
        )}
      </FlexContainer>
    </VerticallyAlignedFlexContainer>
  );
};

const TruncatedTypography12 = styled(Typography12)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ColoredIconButton = styled(StyledIconButton)`
  position: relative;
  background: ${theme.palette.icons.white};
  border: 1px solid ${theme.palette.icons.blue};
  width: 24px;
  height: 24px;
`;

export default LevelUpMeshListHeader;
